export default {"src":"/_next/static/media/harmony-explorer.78440168.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};